import { createPinia } from 'pinia';
import type { Router } from 'vue-router';
import { createPersistedStatePlugin } from 'pinia-plugin-persistedstate-2';
import LocalForage from 'localforage';

/*
 * When adding new properties to stores, you should also
 * extend the `PiniaCustomProperties` interface.
 * @see https://pinia.vuejs.org/core-concepts/plugins.html#typing-new-store-properties
 */
declare module 'pinia' {
  export interface PiniaCustomProperties {
    readonly router: Router;
  }
}

/*
 * This function initializes Pinia with plugins and can be imported into your main.ts file.
 */
export function initializePinia() {
  const pinia = createPinia();

  const localForage = LocalForage.createInstance({
    name: 'sellia-workspace',
    storeName: 'sellia-workspace',
    driver: LocalForage.INDEXEDDB,
  });

  pinia.use(
    createPersistedStatePlugin({
      persist: false,
      storage: {
        getItem: async (key) => {
          return localForage.getItem(key);
        },
        setItem: async (key, value) => {
          return localForage.setItem(key, value);
        },
        removeItem: async (key) => {
          return localForage.removeItem(key);
        },
      },
    }),
  );

  return pinia;
}
